import { makeStyles } from '@/styles/theme/tss-react';

import { darkOrLightStyle } from '@/utils/styles';

interface Props {
  isOnDark: boolean | undefined;
}

const useStyles = makeStyles<Props>({
  name: 'MultipleStacks',
})(({ spacing, breakpoints, brandColors, aspectRatio, typography }, props) => ({
  stackText: {
    display: 'flex',
    flexDirection: 'column',
  },
  link: {
    lineHeight: '130%',
    textDecoration: 'underline',
    color: darkOrLightStyle(props)(brandColors.white, brandColors.black),
    '&:hover': {
      color: darkOrLightStyle(props)(
        brandColors.tintsNeutral20,
        brandColors.tintsOffWhite40
      ),
    },
  },
  bodyContainer: {
    maxWidth: typography.pxToRem(373),
  },
  bodyTwoUp: {
    marginBottom: spacing(2),
  },
  stackedBody: {
    marginBottom: spacing(3),
    [breakpoints.up('md')]: {
      marginBottom: 0,
    },
  },
  singleImage: {
    aspectRatio: aspectRatio['16/9'],
    [breakpoints.up('md')]: {
      aspectRatio: aspectRatio['21/9'],
    },
  },
  doubleImage: {
    aspectRatio: aspectRatio['1/1'],
    [breakpoints.up('md')]: {
      aspectRatio: aspectRatio['16/9'],
    },
  },
  tripleImage: {
    aspectRatio: aspectRatio['1/1'],
    [breakpoints.up('md')]: {
      aspectRatio: aspectRatio['4/3'],
    },
  },
  quadrupleImage: {
    aspectRatio: aspectRatio['1/1'],
  },
  optionalCTAContainer: {
    display: 'flex',
    alignSelf: 'end',
  },
}));

export default useStyles;
